import { Component, Input, OnInit } from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RULE_STATUS } from '../../../../../../../rule-engine/rules/models';
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-rule-actions',
	templateUrl: './rule-actions.component.html'
})
export class RuleActionsComponent {
	@Input() ruleViolation;
	@Input() ruleWorkFlow;
	@Input() activeActions;
	@Input() path;

	public ruleStatus = RULE_STATUS;

	get disableButtons(): boolean {
		let response = false;

		if (this.activeActions === false
			|| this.ruleWorkFlow.disabledActions
			|| this.ruleWorkFlow.processing
		) {
			response = true;
		}

		return response;
	}

	get showLoading(): boolean {
		let response = false;

		if (this.ruleWorkFlow.processing
			&& this.ruleWorkFlow.ruleUpdate.name === this.ruleViolation.ruleName
		) {
			response = true;
		}

		return response;
	}

	constructor(
		private rulesChangeService: RulesChangeService
	) {
		//
	}

	/**
	 * Doc must exist
	 * @param ruleViolation
	 * @param ruleStatus
	 */
	onUpdateStatus(ruleViolation, ruleStatus): void {
		this.rulesChangeService.rulesDataChanged.next({
			type: RulesEvents.UPDATE_STATUS,
			ruleViolation,
			ruleStatus,
			path: this.path
		});
	}

}
